@if (iconUrl) {
  <img class="centered-rounded-icon enabled-app-icon" [src]="iconUrl" />
} @else {
  <span
    class="centered-rounded-icon enabled-app-icon-custom"
    [ngStyle]="{ 'background-color': iconColor }"
    >
    {{ appId[0] }}
  </span>
}
